module.exports = __webpack_public_path__ + "img/loginlogo-origin.d305ba3b.png";